import { Link } from "react-router-dom";
import { codeblaze2 } from "../../../assets/image";

const LogoImage = () => {
  return (
    <Link to="/" className="framer-hlgkof" data-framer-name="Logo Image">
      <div
        className="absolute rounded-inherit top-0 right-0 bottom-0 left-0"
        data-framer-background-image-wrapper="true"
      >
        <img
          className="block w-full h-full rounded-inherit object-center object-contain"
          decoding="async"
          src={codeblaze2}
          alt="logo"
        />
      </div>
    </Link>
  );
};

export default LogoImage;
